import React, { ReactElement } from 'react';

import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const CvaCom = React.lazy(() => import('../components/Cva'));

function Cva(): ReactElement {
  return (
    <SuspenseLoadPage>
      <CvaCom />
    </SuspenseLoadPage>
  );
}

export default Cva;
